import { styled } from '@activebrands/core-web/libs/styletron';
import getContentWrapperStyles from '@activebrands/core-web/utils/style-functions/get-content-wrapper-styles';
import getModuleBottomMarginStyles from '@activebrands/core-web/utils/style-functions/get-module-bottom-margin-styles';

interface ModuleSectionStyleProps {
    $isGrid?: boolean;
    $suppressBottomMargin?: boolean;
}

export const ModuleSection = styled(
    'section',
    ({ $isGrid = false, $suppressBottomMargin = false }: ModuleSectionStyleProps) =>
        getModuleBottomMarginStyles($isGrid, { suppressMargin: $suppressBottomMargin })
);

// ection with standard module bottom spacing and content corridor (max-width + horizontal margins).
export const ModuleContentSection = styled(
    'section',
    ({ $isGrid = false, $suppressBottomMargin = false }: ModuleSectionStyleProps) => ({
        ...getModuleBottomMarginStyles($isGrid, { suppressMargin: $suppressBottomMargin }),
        ...getContentWrapperStyles(),
    })
);
